var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBombshellIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 109.6 132.8",
    style: {
      enableBackground: "new 0 0 109.6 132.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n\t.st2{fill:none;stroke:#000000;stroke-width:4.028;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    className: "st0",
    d: "M66.5,132.8H42.5c-52.4,0-45.9-80.4-35.1-114.2c1.5-2.3,3.3-4.4,5.2-6.3c8-8,18.8-12.4,30-12.4 h23.8c9.8,0,19.3,3.4,26.9,9.6c1.2,1,2.4,2.1,3.5,3.2c11.1,11.5,12,29.4,12.4,44.5c0.4,17.4,1.4,35.8-6.1,52 c-5,10.8-12.9,18.8-28.2,22.7C72.2,132.5,69.3,132.8,66.5,132.8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    y: 0,
    className: "st1",
    width: 109.6,
    height: 132.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    d: "M24.5,8.6c1.9-1.1,3.9-2,6-2.8C52.3-3,74.2,4,86.5,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    className: "st0",
    d: "M30.2,8.2c13.3,0,24.1,10.8,24.1,24.1S43.5,56.3,30.2,56.4S6.1,45.6,6.1,32.3c0,0,0,0,0,0 C6.1,19,16.9,8.2,30.2,8.2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    className: "st2",
    cx: 30.2,
    cy: 32.3,
    r: 24.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    d: "M28.9,15.1c9.2,0,16.6,7.4,16.6,16.6s-7.4,16.6-16.6,16.6s-16.6-7.4-16.6-16.6c0,0,0,0,0,0 C12.3,22.6,19.8,15.1,28.9,15.1L28.9,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    className: "st0",
    d: "M23.4,15.4c4.4,0,7.9,3.5,7.9,7.9s-3.5,7.9-7.9,7.9s-7.9-3.5-7.9-7.9c0,0,0,0,0,0 C15.5,19,19.1,15.4,23.4,15.4C23.4,15.4,23.4,15.4,23.4,15.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    d: "M10.6,56c0.7-0.8,8.8,4.6,22,4.3c6.4-0.1,10.6-1.5,11-0.8s-5.1,5-12,5.6C20,66.2,9.8,57,10.6,56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    className: "st0",
    d: "M78.5,8.2c13.3,0,24.1,10.8,24.1,24.1S91.8,56.4,78.5,56.4S54.5,45.6,54.5,32.3l0,0 C54.5,19,65.2,8.2,78.5,8.2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    className: "st2",
    cx: 78.5,
    cy: 32.3,
    r: 24.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    d: "M77.3,15.1c9.2,0,16.6,7.4,16.6,16.6c0,9.2-7.4,16.6-16.6,16.6s-16.6-7.4-16.6-16.6c0,0,0,0,0,0 C60.6,22.6,68.1,15.1,77.3,15.1L77.3,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    className: "st0",
    d: "M69.5,15.4c4.4,0,7.9,3.5,7.9,7.9s-3.5,7.9-7.9,7.9s-7.9-3.5-7.9-7.9c0,0,0,0,0,0 C61.7,19,65.2,15.4,69.5,15.4C69.5,15.4,69.5,15.4,69.5,15.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    d: "M97.8,56c-0.7-0.8-8.8,4.6-21.9,4.3c-6.4-0.1-10.6-1.5-11-0.8s5.2,5,12,5.6C88.5,66.2,98.7,57,97.8,56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    y: 0,
    className: "st1",
    width: 109.6,
    height: 132.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    y: 0,
    className: "st1",
    width: 109.6,
    height: 132.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombshellIconWhite);
export default __webpack_public_path__ + "static/media/BombshellIconWhite.294fa9a5cd6027116338dae43efcca11.svg";
export { ForwardRef as ReactComponent };